import { computed } from 'vue'

import { convertDateToItsZone } from '@/lib/utils/dates'
import dayjs from '@/lib/utils/dayjs'

import { useSessionStore } from '@/stores/session'

export function useFormat() {
  const sessionStore = useSessionStore()

  const dateFormat = computed(() => {
    if (sessionStore.user.settings.dateFormat?.code === 'ddmmyy') {
      return 'D/M/YY'
    } else {
      return 'M/D/YY'
    }
  })

  const getEuroPriceFormat = (value) => {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }

  const getEngPriceFormat = (value) => {
    return new Intl.NumberFormat('en-EN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }

  const formatPrice = (currency, value) => {
    let formattedVal

    switch (currency) {
      case 'EUR':
        formattedVal = getEuroPriceFormat(value)
        return `${formattedVal} €`
      case 'GBP':
        formattedVal = getEngPriceFormat(value)
        return `£${formattedVal}`
      case 'USD':
      default:
        formattedVal = getEngPriceFormat(value)
        return `$${formattedVal}`
    }
  }

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-EN').format(number)
  }

  const formatPriceNumber = (value) => {
    if (sessionStore.user.settings.currency?.isocode === 'EUR') {
      return getEuroPriceFormat(value)
    } else {
      return getEngPriceFormat(value)
    }
  }

  const formatDate = (date, format = dateFormat.value) => {
    return date ? dayjs(date).format(format) : null
  }

  const formatDateToItsZone = (date, format = dateFormat.value) => {
    return date ? convertDateToItsZone(date, format) : null
  }

  return {
    dateFormat,
    getEuroPriceFormat,
    getEngPriceFormat,
    formatPrice,
    formatNumber,
    formatPriceNumber,
    formatDate,
    formatDateToItsZone,
  }
}
